import _slicedToArray from "/Users/danknasty/linux/Reactive-Resume/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function round(number) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Math.pow(10, digits);
  return Math.round(base * number) / base;
}

function hslaToHsva(_ref) {
  var h = _ref.h,
      s = _ref.s,
      l = _ref.l,
      a = _ref.a;
  var ss = s * ((l < 50 ? l : 100 - l) / 100);
  return {
    h: h,
    s: ss > 0 ? 2 * ss / (l + ss) * 100 : 0,
    v: l + ss,
    a: a
  };
}

var angleUnits = {
  grad: 360 / 400,
  turn: 360,
  rad: 360 / (Math.PI * 2)
};

function parseHue(value) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "deg";
  return Number(value) * (angleUnits[unit] || 1);
}

var HSL_REGEXP = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;

function parseHsla(color) {
  var match = HSL_REGEXP.exec(color);

  if (!match) {
    return {
      h: 0,
      s: 0,
      v: 0,
      a: 1
    };
  }

  return hslaToHsva({
    h: parseHue(match[1], match[2]),
    s: Number(match[3]),
    l: Number(match[4]),
    a: match[5] === void 0 ? 1 : Number(match[5]) / (match[6] ? 100 : 1)
  });
}

function rgbaToHsva(_ref2) {
  var r = _ref2.r,
      g = _ref2.g,
      b = _ref2.b,
      a = _ref2.a;
  var max = Math.max(r, g, b);
  var delta = max - Math.min(r, g, b);
  var hh = delta ? max === r ? (g - b) / delta : max === g ? 2 + (b - r) / delta : 4 + (r - g) / delta : 0;
  return {
    h: round(60 * (hh < 0 ? hh + 6 : hh)),
    s: round(max ? delta / max * 100 : 0),
    v: round(max / 255 * 100),
    a: a
  };
}

function parseHex(color) {
  var hex = color[0] === "#" ? color.slice(1) : color;

  if (hex.length === 3) {
    return rgbaToHsva({
      r: parseInt(hex[0] + hex[0], 16),
      g: parseInt(hex[1] + hex[1], 16),
      b: parseInt(hex[2] + hex[2], 16),
      a: 1
    });
  }

  return rgbaToHsva({
    r: parseInt(hex.slice(0, 2), 16),
    g: parseInt(hex.slice(2, 4), 16),
    b: parseInt(hex.slice(4, 6), 16),
    a: 1
  });
}

var RGB_REGEXP = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;

function parseRgba(color) {
  var match = RGB_REGEXP.exec(color);

  if (!match) {
    return {
      h: 0,
      s: 0,
      v: 0,
      a: 1
    };
  }

  return rgbaToHsva({
    r: Number(match[1]) / (match[2] ? 100 / 255 : 1),
    g: Number(match[3]) / (match[4] ? 100 / 255 : 1),
    b: Number(match[5]) / (match[6] ? 100 / 255 : 1),
    a: match[7] === void 0 ? 1 : Number(match[7]) / (match[8] ? 100 : 1)
  });
}

var VALIDATION_REGEXP = {
  hex: /^#?([0-9A-F]{3}){1,2}$/i,
  rgb: /^rgb\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i,
  rgba: /^rgba\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i,
  hsl: /hsl\(\s*(\d+)\s*,\s*(\d+(?:\.\d+)?%)\s*,\s*(\d+(?:\.\d+)?%)\)/i,
  hsla: /^hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*(\d*(?:\.\d+)?)\)$/i
};
var CONVERTERS = {
  hex: parseHex,
  rgb: parseRgba,
  rgba: parseRgba,
  hsl: parseHsla,
  hsla: parseHsla
};

function isColorValid(color) {
  for (var _i = 0, _Object$entries = Object.entries(VALIDATION_REGEXP); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        regexp = _Object$entries$_i[1];

    if (regexp.test(color)) {
      return true;
    }
  }

  return false;
}

function parseColor(color) {
  if (typeof color !== "string") {
    return {
      h: 0,
      s: 0,
      v: 0,
      a: 1
    };
  }

  if (color === "transparent") {
    return {
      h: 0,
      s: 0,
      v: 0,
      a: 0
    };
  }

  var trimmed = color.trim();

  for (var _i2 = 0, _Object$entries2 = Object.entries(VALIDATION_REGEXP); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        rule = _Object$entries2$_i[0],
        regexp = _Object$entries2$_i[1];

    if (regexp.test(trimmed)) {
      return CONVERTERS[rule](trimmed);
    }
  }

  return {
    h: 0,
    s: 0,
    v: 0,
    a: 1
  };
}

export { isColorValid, parseColor, parseHex, parseHsla, parseHue, parseRgba, round };